module.exports = __webpack_public_path__ + "static/media/mofaheads01@1x.b248e3fa.png";